import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Button } from "../../../components/Wrappers/Wrappers";
import EditForm from "./EditForm";

export default function EditInwardDividendComponent(){
    const { t } = useTranslation();

    return(
        <div>
    <PageTitle title={ t('inwardDividend.edit.pageTitle')} button={<Link to="/app/inward-dividend/list"> <Button
      variant="contained"
      size="medium"
      color="primary"
    >
        { t('inwardDividend.edit.listLink')}
    </Button></Link>} />
    <div>
    <EditForm />
    </div>
            
        </div>
    )
}